import 'rxjs';
import { Observable } from 'rxjs/Observable';
import actions, { LOAD_INDUCTION_SESSIONS } from '../actions';

const loadInductionSessionsEpic = (action$, store, { api }) =>
    action$.ofType(LOAD_INDUCTION_SESSIONS).mergeMap(action =>
        Observable.from(api.fetchInductionSessions(action.payload))
            .map(response => actions.loadInductionSessionsSuccess(response.data))
            .catch(() =>
                Observable.of(
                    actions.loadInductionSessionsFailure('Problem loading induction sessions'),
                ),
            ),
    );

export default loadInductionSessionsEpic;
